module.exports = __webpack_public_path__ + "img/5.10a3178b.jpg";